import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ButtonBase from '@material-ui/core/ButtonBase';
import cn from 'classnames';
import * as React from 'react';
import useStyles from './ActionBarAction.styles';
export const ActionBarAction = ({ className, color, variant, icon, label, fullWidth, selected, disabled, onClick, }, ref) => {
    const classes = useStyles();
    const labelEl = (_jsx("span", Object.assign({ className: cn(classes.label, selected && classes.labelSelected) }, { children: label })));
    return (_jsxs(ButtonBase, Object.assign({ ref: ref, disableRipple: true, className: cn(classes.root, disabled && classes.disabled, fullWidth && classes.fullWidth, variant === 'vertical' && classes.vertical, className), disabled: disabled, onClick: onClick }, { children: [icon && (_jsx("span", Object.assign({ className: cn(classes.icon, color && classes[color]) }, { children: icon }))), label && labelEl] })));
};
// @ts-ignore
export default React.forwardRef(ActionBarAction);
//# sourceMappingURL=ActionBarAction.js.map